import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-quovo-account-modal',
  templateUrl: './quovo-account-modal.component.html',
  styleUrls: ['./quovo-account-modal.component.scss']
})
export class QuovoAccountModalComponent implements OnInit {

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  cancel() {
    this.activeModal.close();
  }

}
